/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class ChatWindowComponent extends Component {
  @service twoWayChat;
}
